import gql from "graphql-tag";

export default gql`
  mutation updateCod($_id: ID!, $update: inputUpdateCOD) {
    updateCod(_id: $_id, update: $update) {
      _id
    }
  }
`;
